import { render, staticRenderFns } from "./registered-detail.vue?vue&type=template&id=59c88be8&"
import script from "./registered-detail.vue?vue&type=script&lang=js&"
export * from "./registered-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/sites/www/new.crt.ru/html/current_version/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59c88be8')) {
      api.createRecord('59c88be8', component.options)
    } else {
      api.reload('59c88be8', component.options)
    }
    module.hot.accept("./registered-detail.vue?vue&type=template&id=59c88be8&", function () {
      api.rerender('59c88be8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/components/registered-detail/registered-detail.vue"
export default component.exports